import { Link, Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slices/auth";
import { useState, useRef, useEffect } from "react";

import Sidebar from "../sidebar";
import {
  KeyboardArrowDown,
  Dashboard,
  Logout as LogoutIcon,
} from "@mui/icons-material";

const DashboardLayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
    localStorage.removeItem("c10sjuex");
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();
  const UserData = useSelector((state) => state.login);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div>
        <nav className="fixed top-0 z-50 w-full bg-white border-b shadow-sm border-gray-200 dark:bg-gray-800 dark:border-gray-700">
          <div className="px-3 py-3 lg:px-5 lg:pl-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center justify-start rtl:justify-end">
                <button
                  onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                  type="button"
                  className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
                >
                  <span className="sr-only">Open sidebar</span>
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>

                <img
                  src="/images/logo.png"
                  className="h-12 me-2"
                  alt="FlowBite Logo"
                />
                <span className="self-center text-xl font-semibold sm:text-2xl whitespace-nowrap dark:text-black hidden sm:block">
                  Sapphire
                </span>
              </div>
              <div className="flex items-center">
                <span className="text-right capitalize">
                  {UserData?.user?.name}
                  <span className="float-left w-full">
                    {UserData?.user?.role?.replace("_agent", " ")}
                  </span>
                </span>

                <div className="ms-2 relative" ref={dropdownRef}>
                  <button
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    type="button"
                    className="flex items-center text-sm focus:outline-none"
                  >
                    <img
                      className="w-12 h-8 rounded-full"
                      src={"/images/logo.png" || UserData?.user?.image}
                      alt="user"
                    />
                    <KeyboardArrowDown className="text-black ml-1" />
                  </button>

                  {dropdownOpen && (
                    <div className="absolute right-0 mt-2 w-44 bg-white rounded-lg shadow-md dark:bg-gray-700 z-50">
                      <ul className="py-2 text-sm text-gray-700 dark:text-gray-200">
                        <li>
                          <Link
                            to="/dashboard"
                            className="flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600"
                            onClick={() => setDropdownOpen(false)}
                          >
                            <Dashboard fontSize="small" className="mr-2" />
                            Dashboard
                          </Link>
                        </li>
                        <li>
                          <button
                            onClick={() => {
                              handleLogout();
                              setDropdownOpen(false);
                            }}
                            className="w-full text-left flex items-center px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600"
                          >
                            <LogoutIcon fontSize="small" className="mr-2" />
                            Logout
                          </button>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </nav>

        <Sidebar
          setIsSidebarOpen={setIsSidebarOpen}
          isSidebarOpen={isSidebarOpen}
        />
        {/* <div className="p-4 sm:ml-64">
          <div className="py-4 mt-8 dashboard-content">
            <Outlet />
          </div>
        </div> */}
      </div>
    </>
  );
};

export default DashboardLayout;
